module.exports = __webpack_public_path__ + "static/media/icon-circle-check.88e8099f.svg";